import { getUrlFileFromAws } from '../services/aws/getUrlFileFromAws';

export const downloadDocument = async (documentUuid: string) => {
  const url = await getUrlFileFromAws(documentUuid);
  window.open(url, '_blank');
};
